<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">Company Data Forms</strong>
        </div>
        <div class="col-md-2">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <vue-tabs v-model="selTab" direction="horizontal" @tab-change="getTabData">
        <!-- <v-tab title="P1"> -->
        <!-- <v-tab :title="alg.name" v-for="(alg, index) in tabs" v-bind:key="index">
          <component :is="widgetView"></component>
        </v-tab> -->
        <v-tab title="Global Settings">          
             <!-- <component ref="pfrm" :is="widgetView"></component>
               {{pDataType}} -->
          <div class="row">
            <div class="col-md-12">
              <GSForm></GSForm>
            </div>
          </div>
        </v-tab>
        <v-tab title="Benchmark">          
             <!-- <component ref="pfrm" :is="widgetView"></component>
               {{pDataType}} -->
          <div class="row">
            <div class="col-md-12">
              <GBForm></GBForm>
            </div>
          </div>
        </v-tab>
        <v-tab title="Competitveness Benchmark">          
             <!-- <component ref="pfrm" :is="widgetView"></component>
               {{pDataType}} -->
          <div class="row">
            <div class="col-md-12">
              <competitiveBenchmark></competitiveBenchmark>
            </div>
          </div>
        </v-tab>
        <v-tab title="Company Edit">          
             <!-- <component ref="pfrm" :is="widgetView"></component>
               {{pDataType}} -->
          <div class="row">
            <div class="col-md-12">
              <companyEdit></companyEdit>
            </div>
          </div>
        </v-tab>
      </vue-tabs>
    </div>
  </div>
  <!-- </card> -->
</template>  
<script>
import GSForm from "@/views/manual-forms/globalSettings";
import GBForm from "@/views/manual-forms/global-benchmark";
import competitiveBenchmark from "@/views/manual-forms/competitvenessBenchmark";
import companyEdit from "@/views/manual-forms/company-edit";
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
export default {
  components: { GSForm, GBForm, competitiveBenchmark, companyEdit },
  mixins: [commonMixins],
  created() {},
  data() {
    return {
      tabs: [
        { title: "gbsettings", name: "Global Settings", comp: "GSForm" },
        { title: "benchmark", name: "Benchmark", comp: "GBForm" },
        { title: "compEdit", name: "Company Edit", comp: "companyEdit" }
      ],
      selTab: ""
    };
  },
  created() {
    if (!localStorage.getItem("compFormTab")) {
      // this.selTab = 'General Info';
      localStorage.setItem("compFormTab", "0");
    } else {
      this.selTab =
        localStorage.getItem("compFormTab") === "0"
          ? ""
          : localStorage.getItem("compFormTab");
    }
  },
  methods: {
    getTabData(tabIndex, newTab, oldTab) {
      console.log(tabIndex, newTab.title, oldTab);
      this.selTab = tabIndex;
      localStorage.setItem("compFormTab", this.selTab);
    }
  },
  computed: {
    widgetView() {
      if (this.selTab !== "") return this.tabs[this.selTab].comp;
      else return this.tabs[0].comp;
    }
  }
};
</script>
<style>
form {
  padding: 10px;
}
form .col-md-3 {
  width: 40%;
}
</style>
/* .vue-tabs .nav-stacked > li {
  width: 100%;
}
.vue-tabs .nav > li span.title{
  justify-content: left;
}
.vue-tabs .nav-stacked > li + li {
  margin-right: 5px;
}
.left-vertical-tabs {
  width: 15%;
}
.tab-content.right-text-tabs {
  width: 85%;
}
.tab-content {
  border: none;
  border-left: 1px solid #c2cfd6 !important;
} */
</style>




// WEBPACK FOOTER //
// src/views/manual-forms/company-data-forms.vue